import styled from 'styled-components';

export default styled.div`
  height: 100%;
  min-height: 500px;
  width: 900px;
  max-width: 100%;
  margin: auto;
  padding: 20px;
  padding-bottom: 140px;
`;



// WEBPACK FOOTER //
// ./src/components/common/PageContainer/index.js